import script from "./CardTemplate.vue?vue&type=script&setup=true&lang=ts"
export * from "./CardTemplate.vue?vue&type=script&setup=true&lang=ts"

import "./CardTemplate.vue?vue&type=style&index=0&id=21056f88&scoped=true&lang=scss"

import exportComponent from "C:\\BuildAgent\\work\\7605b49a72e2e39\\AutoProc\\Solution\\Clientapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-21056f88"]])

export default __exports__